import React from 'react';

interface Props {
    item: any
}
export function ChangeLogModalContent(props: Props) {

    if (props?.item === null) return null;

    return (
        <>
          {props?.item}              
        </>
    );
}
